/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Role_BeInputs */

const en_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Developer · Back-end`)
};

const ar_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطور برمجيات · واجهة خلفية`)
};

const bn_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ডেভেলপার · ব্যাক-এন্ড`)
};

const de_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softwareentwickler · Back-End`)
};

const es_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador de software · Back-end`)
};

const fr_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur de logiciels · Back-end`)
};

const pt_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor de software · Back-end`)
};

const zh_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件开发人员 · 后端`)
};

const tr_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yazılım Geliştiricisi · Arka uç`)
};

const ru_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик программного обеспечения · Серверная часть`)
};

const pl_resume_role_be = /** @type {(inputs: Resume_Role_BeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programista · Back-end`)
};

/**
* | output |
* | --- |
* | "Software Developer · Back-end" |
*
* @param {Resume_Role_BeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_role_be = /** @type {((inputs?: Resume_Role_BeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Role_BeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_role_be(inputs)
	if (locale === "bn") return bn_resume_role_be(inputs)
	if (locale === "de") return de_resume_role_be(inputs)
	if (locale === "es") return es_resume_role_be(inputs)
	if (locale === "fr") return fr_resume_role_be(inputs)
	if (locale === "pt") return pt_resume_role_be(inputs)
	if (locale === "zh") return zh_resume_role_be(inputs)
	if (locale === "tr") return tr_resume_role_be(inputs)
	if (locale === "ru") return ru_resume_role_be(inputs)
	if (locale === "pl") return pl_resume_role_be(inputs)
	return en_resume_role_be(inputs)
});